import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-20 text-white sm:px-8" data-id="element-63" data-mp="vg7pvxdc1yh7">
      <div className="mx-auto w-full max-w-2xl" data-id="element-64" data-mp="19ep7ddcnaeqo">
        <Reveal data-id="element-65" data-mp="19gifkx2wp70s">
          <h2 className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-66" data-mp="19cur4ccbjasx">
            Your next practice can keep being improvised.{' '}
            <span className="text-brand" data-id="element-67" data-mp="1jbaga9rsc9zs">Or you can finally have a real system.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-68" data-mp="1ebxrhjhcssuk">
          <div className="mx-auto mt-12 max-w-md rounded-card border border-white/10 bg-ink p-6 sm:p-7" data-id="element-69" data-mp="1t3g6pf2e2jcv">
            <div className="flex items-end justify-between gap-4" data-id="element-70" data-mp="1o3bqzr9b1snp">
              <div data-id="element-71" data-mp="1o67oxfl5khc5">
                <p className="font-display text-base font-extrabold uppercase leading-snug tracking-tight" data-id="element-72" data-mp="223cy3og5xwbm">
                  Flag Football Ready — Complete Pack
                </p>
                <p className="mt-1 text-sm text-white/65" data-id="element-73" data-mp="n5m6a278a41v">10 volumes + 5 bonuses</p>
              </div>
              <p className="font-display text-5xl font-black leading-none tracking-tight text-brand" data-id="element-74" data-mp="s4pdntaokmd0">
                $27
              </p>
            </div>

            <div className="mt-6" data-id="element-75" data-mp="x27d8t2t5p8c">
              <CtaButton data-id="element-76" data-mp="122vcu353ree6" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}